module.exports = {
  qqgdscpjypt: "全球大宗水产品交易平台",
  qqgdscpjypt1: "全球大宗水产品交易平台",
  // qqgdscpjypt2: "（暨全球高端水产品交易平台）",
  zczh: "注册账号",
  yzmdl: "验证码登录",
  zhmmdl: "账号密码登录",
  sjh: "手机号",
  yzm: "验证码",
  yhylsjh: "银行预留手机号",
  qsrsjh: "请输入手机号",
  qsryzm: "请输入验证码",
  hqyzm: "获取验证码",
  qsrmm: "请输入密码",
  dl: "登录",
  dlsb: "登录失败",
  dlgqqcxdl: "登陆过期,请重新登陆...",
  zc: "注册",
  zcsb: "注册失败",
  yzmbnwk: "验证码不能为空",
  hqyzmsb: "获取验证码失败",
  yzmfscg: "验证码发送成功",
  sjhbnwk: "手机号不能为空",
  sjhgscw: "手机号格式错误",
  mmbnwk: "密码不能为空",
  mmtips: "密码必须是8-16位的英文字母、数字、字符，组合（不能是纯数字）",
  bottomcopyright1: "2023水产品交易中心 ICP证：京ICP备16005856号",
  bottomcopyright2: "京公网安备 11010802026156号",
  ztsc: "主题市场",
  hello: "您好",
  qrz: "去认证",
  rzhjkckjyxqy: "认证后即可查看交易详情页",
  qkh: "去开户",
  khhjkzptwcjy: "开户后即可在中心完成交易",
  khsbxycxkh: "开户失败，需要重新开户",
  qyz: "去验证",
  dzhyz: "待账户验证",
  rzqyykhqlxkf: "认证企业已经开户,请联系客服",
  zljyz: "资料校验中",
  shz: "审核中",
  clz: "处理中",
  dzqyz: "电子签约中",
  jnrzbzj: "缴纳入驻保证金",
  jnrzbzjhkschy: "缴纳入驻保证金后可上传货源",
  wyhyxzzycjj: "我有货源，想组织一场竞价",
  wyhyxzjmc: "我有货源，想直接卖出",
  yrz: "已认证",
  hyzx: "行业资讯",
  gd: "更多",
  qb: "全部",
  zq: "专区",
  kssj: "开市时间",
  ksz: "当前开市中",
  xsz: "当前休市中",
  xqyzxqldsj: "星期一至星期六（节假日除外）",
  morning: "上午:09:00-11:30",
  zwsj: "9:00-16:30",
  jjmc: "竞价卖出",
  jjmr: "竞价买入",
  wyddxzzycjj: "我有订单，想组织一场竞价",
  gpmc: "挂牌卖出",
  gpmr: "挂牌买入",
  wyddxsgyphy: "我有订单，想收购一批货源",
  bhtjy: "包含**条交易",
  bh: "包含 ",
  jyy: "条交易",

  jjkp: "即将开拍",
  jjks: "即将开始",
  bmz: "报名中",
  jxz: "进行中",
  yjs: "已结束",
  lp: "流拍",
  wbmd: "我报名的",
  zxsc: "最新上传",
  kpsj: "开拍时间",
  w: "我",
  wd: "我的",
  jg: "价格",
  qpj: "起拍价",
  dqj: "当前价",
  cjj: "成交价",
  yuan: "元",
  zwxgxx: "暂无相关内容",

  ryd: "10人阅读",
  qxdzcg: "取消点赞成功",

  bm: "报名",
  xzkhjl: "新增看货记录",
  jbxx: "基本信息",
  hymc: "货源名称",
  qsrhymc: "请输入货源名称",
  dw: "单位",
  djtxdw: "点击填写单位",
  tiao: "条",
  dun: "吨",
  zl: "重量",
  hydz: "货源地址",
  hyzp: "货源照片",
  scp: "上传照片",
  zdjz: "（最多9张）",
  bcqtxx: "其他补充信息",
  bcbtj: "保存并提交",
  cjfdxdydqjg: "出价幅度需大于当前价格",
  fscgddmfqr: "发送成功，等待卖方确认",
  cjcg: "出价成功",
  cjsb: "出价失败",

  sy: "首页",
  rz: "认证",
  grrz: "个人认证",
  gsrz: "公司认证",
  sczj: "上传证件",
  xm: "姓名",
  qsrxmxysfzbcyz: "请输入姓名,须与身份证保持一致",
  ztlx: "主体类型",
  djxzlx: "点击选择类型",
  jysx: "经营属性",
  djxzsx: "点击选择属性",
  jydz: "经营地址",
  djxzdz: "点击选择地址",
  xxdz: "详细地址",
  qsrxxdz: "请输入详细地址",
  jypx: "经营品项",

  djxzpx: "点击选择品项",
  gsmc: "公司名称",
  qsrgsmcxyyyzzyz: "请输入公司名称，须与营业执照名称一致",
  qsrgsmc: "请输入公司名称",
  lxr: "联系人",
  qsrlxr: "请输入联系人",
  qscsfz: "请上传身份证",
  qscsfzwssfxx: "请上传身份证完善身份信息",
  qpsbscndyyzz: "请拍摄并上传你的营业执照",
  djscsfzzm: "点击上传身份证正面",
  djscsfzbm: "点击上传身份证背面",
  djscyyzz: "点击上传营业执照",
  tj: "提交",
  tjrz: "提交认证",
  thcg: "提交成功",
  tjsb: "提交失败",
  yqm: "邀请码",
  yqmxt: "邀请码（选填）",
  qtxyqm: "请填写邀请码",
  sryqmrwkbt: "输入邀请码，若无可不填",
  qd: "确定",
  qx: "取消",
  sctpyc: "上传图片异常",
  sfzxmysrxmbyzqcxtr: "身份证姓名与输入姓名不一致，请重新填写～",
  yyzzmcysrmcbtzqcxtx: "营业执照的名称与输入名称不一致，请重新填写～",
  tpsbycqcxsc: "图片识别异常,请检查上传图片信息",
  rzsb: "认证失败",
  rzyc: "认证异常",
  qsryqm: "请输入邀请码",

  grzx: "个人中心",
  zhye: "账户余额",
  wdye: "我的余额",
  ljczlc: "了解充值流程",
  tx: "提现",
  bccg: "保存成功",
  bcsb: "保存失败",
  bcyhcw: "保存用户错误",
  txtp: "头像图片",
  bdsjh: "绑定手机号",
  hb: "换绑",
  dlmm: "登录密码",
  qsz: "去设置",
  xgmm: "修改密码",
  szmm: "设置密码",
  qr: "确认",
  djscndtx: "点击上传您的头像",
  hbsjh: "换绑手机号",
  qsrhbsjh: "请输入换绑手机号",
  dqsjh: "当前手机号",
  ghcg: "更换成功",
  xgcg: "修改成功",
  szcg: "设置成功",
  uploatips: "上传文件大小不能超过 5MB",
  success: "成功",
  fail: "失败",

  zhmx: "账户明细",
  mj: "卖家",
  maij: "买家",
  dj: "冻结",
  djmx: "冻结明细",
  yjcdj: "已解除冻结",
  zrtxje: "转入提现明细",
  pfmx: "赔付明细",

  rzbzj: "入驻保证金",
  bzjtips: "若卖方客户发起交易，入驻保证金须不低于10万元整。",
  bzjtips1: "试运营阶段，暂不实施此规定",
  zcdz: "转出",
  zrdz: "转入",

  qrcj: "确认出价",
  hpmc: "货品名称",
  zxjg: "最新价格",
  ykj: "一口价",
  jpcj: "竞拍出价",
  cjf: "出价方",
  dunshu: "吨数",
  zdbmds: "最低报名吨数",
  grds: "购入吨数",
  cjje: "出价金额",
  qsrndgrds: "请输入您的购入吨数",
  qsrndcjje: "请输入您的出价金额",

  wddd: "我的订单",
  hyd: "货源地",
  shd: "收货地",
  djkckmfhy: "可点击查看卖方货源",
  hyzj: "货源总价",
  djtips: "定金（冻结履约保证金冲抵货款）",
  fwf: "服务费",
  wk: "尾款",
  ddbh: "订单编号",
  copy: "复制",
  cjsj: "创建时间",
  mffk: "买家付款",
  ccbg: "出厂报告",
  zskf: "专属客服",
  hckf: "华采客服",
  dfpkf: "待分配品控...",
  lxpk: "联系品控",
  qfk: "去付款",

  txmfhy: "填写卖方货源",
  ckmfhy: "查看卖方货源",
  hyxx: "货源信息",
  ddxx: "订单信息",
  ksrbcne: "可输入补充内容..",
  bt: "必填",
  xt: "选填",
  fsgmf: "发送给买家",

  sztx: "设置提醒",
  sztxcg: "设置提醒成功",
  qxtxcg: "取消提醒成功",
  szsb: "设置失败",
  qxbmcg: "取消报名成功",
  ysz: "已设置",
  jjs: "距离结束",
  jks: "距离开始",
  sc: "时长",
  kdjckkhjl: "可点击查看看货记录",
  bm10sr: "报名**人",
  wg10ren: "围观**次",
  jybh: "交易编号",
  jplx: "竞拍类型",
  jjfd: "加价幅度",
  jjfdjj: "降价幅度",
  jpsj: "竞拍时间",
  jpsc: "竞拍时长",
  fz: "分钟",
  yszq: "延时周期",
  jylx: "交易类型",
  scsj: "上传时间",
  lxdh: "联系电话",
  ppxq: "拍品详情",
  pkbb: "品控报告",
  cjjl: "出价记录",
  xqms: "需求描述",
  hyms: "货源描述",
  jjr: "竞价人",
  sj: "时间",
  ckgd: "查看更多",
  zwcjjl: "暂无出价记录",
  smewmdsj: "扫描二维码到手机",
  dqrp: "当前热拍",
  yhwrzqdgezxrz: "用户未认证，请前往个人中心进行认证",

  ckkhxx: "查看看货信息",
  lsjl: "历史记录",
  bmcg: "报名成功",
  dmfqr: "待买家确认",
  mfjj: "买家拒绝",
  mfcswcl: "买家超时未处理",
  bj: "编辑",
  delete: "删除",
  qrxgfsgmf: "确认修改发送给买家",
  qrscgkhxx: "确认删除该看货信息？",
  sccg: "删除成功",
  ldfs: "冷冻方式",
  jjsz: "竞价设置",
  jjrq: "竞价日期",
  djxzjjrq: "点击选择竞价日期",
  jjsj: "竞价时间",
  djxzjjsj: "点击选择竞价时间",
  jjsc: "竞价时长",
  djxxjjsc: "点击选择竞价时长",
  srsz: "输入数字",
  gpsz: "挂牌设置",
  jgsz: "交割设置",
  yf: "运费",
  djlybzj: "冻结履约保证金",
  tjhddsh: "提交后等待审核",

  bmlb: "报名列表",
  dqr: "待确认",
  yjj: "已拒绝",
  yqr: "已确认",
  bmbh: "报名编号",
  bmsj: "报名时间",
  sfjjbm: "是否拒绝报名?",

  syrzbzjy: "剩余入驻保证金（元）",
  rzbzjtips1: "若卖家客户发起交易，入驻保证金须不低于10万元整",
  zrje: "转入金额",
  qsrzrje: "输入转入金额",
  qbzr: "全部转入",
  yczr: "由此转入",
  zrcg: "转入成功",
  zrsb: "转入失败",

  zcje: "转出金额",
  qsrzcje: "输入转出金额",
  qbzc: "全部转出",
  zcz: "转出至",
  zccg1: "转出成功",
  zcsb1: "转出失败",

  ktzfzh: "开通支付账号",
  grkh: "个人开户",
  qykh: "企业开户",
  gtgshkh: "个体工商户开户",
  khsb: "开户失败",
  wdyhk: "我的银行卡",
  yjhb: "一键换绑",
  bdyhk: "绑定银行卡",
  zhlx: "账户类型",
  qdjxz: "请点击选择",
  dgzh: "对公",
  dszh: "对私",
  ckr: "持卡人",
  qsrckrxm: "请输入持卡人姓名",
  qsrxm: "请输入姓名",
  yhkh: "银行卡号",
  qsrkh: "请输入卡号",
  khh: "开户行",
  qsrkhh: "请输入开户行",
  zcyh: "支持银行",

  wfbd: "我发布的",
  wdjy: "我的交易",
  wgzd: "我关注的",
  qtgn: "其他功能",

  yx: "邮箱",
  dz: "地址",
  kfzsewm: "客服专属二维码",
  qtxzgcyhdwzs: "请填写中关村银行向该对公账户打款金额",
  skjey: "收款金额（元）",
  ytjqnxddsh: "已提交，请耐心等待审核！",

  yey: "余额（元）",
  txje: "提现金额",
  qsrtxje: "输入提现金额",
  qbtx: "全部提现",
  dzyhk: "到账银行卡",

  jjcj: "竞价出价",
  ydzdcj: "已到最低出价",
  zklyx: "再考虑一下",
  jjcg: "竞价成功",
  jyts: "交易提示",
  qrybdyhk: "确认已绑定银行卡",
  syysyhkxrxzhhk: "使用以上银行卡向如下账户汇款",
  zhm: "账户名",
  zhzh: "账号",
  zhc: "张华采",
  bjyhzgczh: "北京中关村银行股份有限公司",
  xzf: "需支付",
  wkyf: "尾款应付",
  xzzffs: "选择支付方式",
  wdzh: "我的账户",
  qrzf: "确认支付",
  zhyebzljzr: "账户余额不足，了解转入",
  zfcg: "支付成功",
  bmxz: "报名须知",
  dqbdlybzj: "当前标的履约保证金",
  ndzhye: "您的账户余额",
  bmjjjbstyxydjbzj: "报名竞价即表示同意冻结对应履约保证金",
  rwhpjth: "若未获拍，冻结的履约保证金会自动解除冻结状态",
  rcgzcdhk: "若成功获拍，冻结的履约保证金会在您交付尾款时作为定金冲抵货款",
  rcgpxjkc: "若您成功拍下后未履约，冻结的保证金将被扣除",
  zhyebzwfbm: "账户余额不足，无法报名",
  qzr: "去转入",
  qrbm: "确认报名",

  zd: "转到",
  ye: "页",

  scxgzj: "上传相关证件",
  qscyyzz: "请上传营业执照",
  yyqx: "营业期限",
  qsryyqx: "请输入营业期限",
  zcdz1: "注册地址",
  qsrzcdz: "请输入注册地址",
  tyshxydm: "统一社会信用代码",
  qsrtyshxydm: "请输入统一社会信用代码",
  qsczzjgdmz: "请上传组织机构代码证",
  djsczzjgdmz: "点击上传组织机构代码证",
  zzjgdm: "组织机构代码",
  qsrzzjgdm: "请输入组织机构代码",
  zzjgdmzqx: "组织机构代码证期限",
  qsrzzjgdmzqx: "请输入组织机构代码证期限",
  qscswdjz: "请上传税务登记证",
  djscswdjz: "点击上传税务登记证",
  swdjzdm: "税务登记证代码",
  qscfrsfz: "请上传法人身份证",
  sfzh: "身份证号",
  qsrsfzh: "请输入身份证号",
  sfzyxq: "身份证有效期",
  qsryxq: "请输入有效期",
  qsclxrsfz: "请上传联系人身份证",
  lxrxm: "联系人姓名",
  lxrsfzh: "联系人身份证号",
  lxrsjh: "联系人手机号",
  qsrlxrsjh: "请输入联系人手机号",
  lxryx: "联系人邮箱",
  qsrlxryx: "请输入联系人邮箱",
  zhmc: "账户名称",
  qsrzhmc: "请输入账户名称",

  wdfb: "我的发布",
  tcdl: "退出登录",
  smjrxcx: "扫描进入小程序",
  czgjfbkj: "操作更加方便快捷",
  ss: "搜索",
  tgsh: "通过审核",
  js: "结束",
  bohui: "驳回",
  scdd: "生成",
  xgjg: "改价",
  qdgj: "确定改价",
  xjhyyy: "下架",
  bmhy: "报名货源",
  ckdd: "查看订单",
  pkdh: "品控电话",
  bmdjj: "报名的竞价",
  bmdgp: "报名的挂牌",
  dzdwz: "点赞的文章",
  mairu: "买入",
  maichu: "卖出",
  grxx: "个人信息",
  grsy: "个人首页",
  quhao: "区号",
  dfk: "待付款",
  djg: "待交割",
  ywc: "已完成",
  qt: "其他",
  dsh: "待审核",
  zsz: "展示中",
  nhqdl: "您好请登录",
  mfzc: "免费注册",

  jyzx: "交易中心",
  hyzx11: "行业资讯",
  qgsj: "全国数据",
  qqsj: "全球数据",
  cczx: "服务中心",
  gzzx: "平台规则",
  lxwm: "联系我们",
  sjzx: "价格指数",
  grzxxx: "个人中心",

  szgjjqyjyzx: "深圳国际金枪鱼交易中心",
  qqgdscpjyzx: "全球大宗水产品交易平台",
  djjrjyzx: "点击进入交易中心",
  gjst: "共建生态",
  hzgyy: "合作共赢",
  gongsijieshao: "公司介绍",
  pingtaijieshao: "中心介绍",
  dazaoqqzddyyjypt: "打造全球高端水产品在线交易中心",
  gsjstips111:
    "由中国农业发展集团下属中水集团远洋股份有限公司发起，华采科技（北京）有限公司提供技术和专业的支持。",
  lliaojiexiangq: "了解详情",
  guankanship: "观看视频",
  xianshangjiaxianxia: "“线上”+“线下”",
  gsjstips222:
    "公司致力于打造全球高端水产品在线交易中心，以“线上”+“线下”双引擎驱动，将异地高端水产品通过远程数字化交易中心与现场拍卖交易实现联动。",
  sjzgrdbzsrjg: "升级中国人的蛋白质摄入结构",
  gsjstips333:
    "以大食物观以指导，以共建生态、合作共赢为理念，以科技为手段推动高端水产品的产业数字化进程，提升全球高端水产品的交易流通效率，升级中国人的蛋白质摄入结构，重构全球高端水产品数字化新生态。",
  gaoduanshuichanpzonghefuwupingtai: "高端水产品综合产业服务中心",
  gsjstips444:
    "经深圳市政府批准，由中国农业发展集团、深圳港集团共同发起，由北京华采提供技术支持。做为深圳国家远洋渔业基地的先导项目投入运营。中心于2023年5月12日正式上线，是以高端水产品现货交易为主，集水产品标准制定、新品种研发推广，市场信息服务、技术服务、金融服务、物流服务为一体的高端水产品综合产业服务中心。",
  pingtai1: "覆盖全球主要金枪鱼交易中心城市",
  pingtai2:
    "中心以深圳为枢纽，链接大连、烟台、舟山、东京、高雄、曼谷等全球重要金枪鱼集散地城市，设立交割仓，实现全球交割； 中心除金枪鱼以外，还涵盖银鳕鱼、三文鱼、帝王蟹、龙虾等高端水产品品种。",
  pingtai3: "交易国际化、标准化、信息化和数字化",
  pingtai4:
    "中心承担着推动全球高端水产品产业的创新升级，实现水产品交易国际化、标准化、信息化和数字化的重任；中心将利用强有力的市场化运营能力、资源整合能力及优惠的政策配套资源，逐步建成亚太地区国际高端水产品交易、结算和定价中心。",
  adv1: "我们的优势",
  adv2: "云端交易、全球交割、专享资源、深圳价格",
  adv3: "高端",
  adv4: "高效",
  adv5: "高品质",
  adv7: "高质量",
  adv6: "打造亚太地区高端水产交易中心、结算中心、定价中心",
  cloud1: "云端交易",
  cloud2: "全球交割",
  cloud3: "专享资源",
  cloud4: "深圳价格",
  cloud5: "全程溯源",
  cloud6: "AI质检",
  cloud7: "数据引擎",
  cloudIntro1: "云端交易，一键买全球、卖全球，交易无限触达",
  cloudIntro2: "全球交割，全球主要集散地城市当地交割，降低物流成本",
  cloudIntro3: "专享资源，远洋蓝鳍金枪鱼全部捕捞配额，指定销售渠道",
  cloudIntro4:
    "深圳价格发布全球金枪鱼集散地城市实际交易价格，助力中国市场确立定价中心地位",
  cloudIntro5: "产品全程溯源，还原产品真实信息，一鱼一码，实现百分百食用安全",
  cloudIntro6:
    "AI图像识别强化品控能力，通过统一检测标准降低传统验鱼误差，提高多场景应用效率",
  cloudIntro7: "数据引擎，通过大数据挖掘，增强决策准确度",
  gsdzzzzz: "公司地址：北京市朝阳区八里庄陈家林9号院华腾世纪总部公园E1座601A",
  xcxxxx: "小程序",
  fwhhhh: "服务号",
  wzdhhh: "网站导航",
  pzzx: "交割中心",

  login1: "共创生态 合作共赢",
  login9: "以科技推动高端水产品数字化进程",
  login11: "立即登录",

  person1: "个人首页",
  person2: "个人信息",
  person7: "开户流程",

  qkk: "去看看",
  wfbdjy: "我发布的交易",
  rxtel: "热线",
  kfrxxx: "客服热线",
  gzsjjj: "工作时间",
  jqy: "金枪鱼",
  qtpl: "其他品类",
  cjjjj: "成交",
  qpppp: "起拍",
  plll: "品类",
  pxxx: "品项",

  jqyfl: "金枪鱼分类",
  zzjx: "正在进行",
  jssj: "结束时间",
  ysztx: "已设置提醒",
  dpsjgzg: "大屏数据更直观",
  cdxx: "产地信息",
  ggzbjdx: "规格占比及大小",
  hours: "时",
  minus: "分",
  second: "秒",
  wxsys: "微信扫一扫",

  service1: "我们有哪些服务",
  service2: "用我们的服务全面赋能实现业务增长",
  service3: "金融服务",
  service4:
    "旨在为上下游客户提供全方位的金融支持，帮助他们解决资金周转难题，提高交易效率，降低交易成本",
  service5: "全面",
  service6: "物流服务",
  service7:
    "旨在为上下游客户提供高效、便捷的物流支持，帮助他们更好地完成交易和物流配送",
  service8: "高效",
  service9: "数据服务",
  service10:
    "旨在为上下游客户提供全面、及时、准确的交易数据和市场信息，帮助他们了解市场动态和趋势，做出更明智的交易决策",
  service11: "专业",
  service12: "全面了解",
  service13:
    "包含融资服务、结算服务、风险管理服务等，旨在为上下游客户提供全方位的金融支持，帮助他们解决资金周转难题，提高交易效率，降低交易成本，中心还计划进一步拓展金融服务，包括建立金融产品创新中心等，为上下游客户提供更加全面、专业的金融服务。",
  service14:
    "包括仓储服务、配送服务、报关服务、保险服务等，旨在为上下游客户提供高效、便捷的物流支持，帮助他们更好地完成交易和物流配送。中心还计划进一步拓展物流服务，包括建立物流信息平台、开发物流管理SAAS工具等，为上下游客户提供更加全面、高效的物流支持。",
  service15:
    "包括实时行情数据、交易数据分析、市场信息发布、数据定制服务等，旨在为上下游客户提供全面、及时、准确的交易数据和市场信息，帮助他们了解市场动态和趋势，做出更明智的交易决策。中心还计划进一步拓展数据服务，包括建立数据中心、开发数据分析软件等，为上下游客户提供更加全面、专业的数据支持。",
  slx: "数量（箱）",
  cdmc: "产地名称",
  rknf: "入库年份",
  rkyf: "入库月份",
  ggzbjdxplace:
    "请写出货源包含的规格占比及大小情况，例如：规格100-150占比25%，偏大；规格200-3000占比75%，正常大小",
  rules1: "全球大宗水产品交易平台规则汇总（试用）",
  rules2: "第一章 总则",
  rules3: "第一条",
  rules4:
    "为规范全球大宗水产品交易平台的线上交易规则（以下简称本平台），维护市场秩序，保障会员的合法权益，根据《中华人民共和国民法典》、《中华人民共和国拍卖法》、《第三方电子商务交易中心服务规范》等相关法律法规等规定，制定本细则。",
  rules5: "第二条",
  rules6:
    "本规则适用于在全球大宗水产品交易平台的交易活动。交易中心所有的工作人员、会员、做市商、交收仓库及相关合作机构必须遵守本规则。",
  rules7: "第二章 交易",
  rules8: "第三条 开市时间",
  rules9: "1.周一至周六：每天 9:00-16:30；",
  rules10: "2.周日和法定节假日不开市",
  rules11: "第四条 收费标准",
  rules12:
    "买卖双方根据不同的交易方式、品类需支付不同的费用，详细请参考《平台收费标准》",
  rules13: "角色",
  rules14: "买家",
  rules15: "卖家",
  rules16: "发起交易模式",
  rules17: "交易规则",
  rules18: "买家上传采购需求，设置起拍价，卖家根据买家需求进行竞价，价低者得。",
  rules19: "买家上传采购需求，设定了价格与数量等门槛，卖家根据买家需求售卖。",
  rules20: "卖家上传售卖货物，设置起拍价，买家根据卖家需求进行竞价，价高者得。",
  rules201:
    "卖家上传售卖货源明细，设置起拍价，买家根据卖家需求进行竞价，价高者得。",
  rules21:
    "卖家上传货物明细，设定了价格与数量等门槛，买家根据卖家货物情况购买。",
  rules22: "中心收费标准",
  rules23: "（暂行）",
  rules24: "参与交易的买家收取服务费100元/吨",
  rules25: "参与交易的卖家收取5‰的交易佣金",
  rules26: "保证金",
  rules27:
    "交易保证金：买家需要先缴纳货款的20%的交易保证金作为定金，成交后，该定金将冲抵货款",
  rules28: "商户入驻中心保证金100000元",
  rules29: "付款及发货时间",
  rules30: "下单后24小时内缴纳尾款",
  rules31: "（如逾期需联系中心处理）",
  rules32: "买家付清全款后48小时内发货",
  rules33: "第五条",
  rules34: "报价币种为人民币，报价单位为：根据品类的要求具体设定。",
  rules35: "第六条",
  rules36:
    "所有用户须缴纳足额保证金后方可在本交易平台作为买卖家，正常参与发布卖出/买入或报名/出价。",
  rules37: "第七条 交易保证金",
  rules38:
    "买卖家需根据交易中心的要求缴纳相应的交易保证金，交易成功后，保证金将冲抵货款。",
  rules39: "第八条 保证金退还",
  rules40: "符合退还条件的，一般会在2个工作日原路径退回付款账户。",
  rules41: "第九条 保证金扣罚",
  rules42:
    "卖家发布的货源被成功竞拍，涉及如下情形中任何一条，将被扣罚与成交额等值的保证金，若保证金不足则扣除已缴纳全额：",
  rules43: "1.交割货源质量与描述严重不符；",
  rules44: "2.未按照规定的时间和程序，完成货物交割办理；",
  rules45: "3.未按照拍卖公示价格履行合约。",
  rules46: "4.中心将扣罚与成交额等值的保证金，若保证金不足则扣除已缴纳全额。",
  rules47:
    "如买家竞拍成功后，涉及如下情形中任何一条，将被扣罚与成交额等值的保证金，若保证金不足则扣除已缴纳全额：",
  rules48: "1.未按照规定的时间和程序，完成货物交割办理；",
  rules49: "2.未按照拍卖公示价格履行合约。",
  rules50: "3.中心将扣罚与成交额等值的保证金，若保证金不足则扣除已",
  rules51: "第十条 保证金罚没去向",
  rules52:
    "1.竞拍成功，但买家未在竞拍结束后的1个自然日（交易付款期内）及时完成付款，且该笔交易不支持协商恢复交易的，买家缴纳的保证金将在交易付款期结束后被罚没并赔付给卖家。",
  rules53:
    "2.竞拍成功，但买家未在竞拍结束后的2个自然日（交易付款期内）及时完成付款，且该笔订单在协商恢复交易期内未申请恢复交易，买家缴纳的保证金将在恢复交易期结束后被罚没并赔付给卖家。",
  rules54:
    "3.竞拍成功，但买家未在竞拍结束后的1个自然日（交易付款期内）及时完成付款，且该笔订单在协商恢复交易期内申请恢复但未被卖家处理或被拒绝恢复交易，买家缴纳的保证金在被拒绝恢复交易后被罚没并赔付给卖家。",
  rules55:
    "4.缴纳了保证金的卖家在成交后未依约向买家交付拍品的，卖家缴纳的保证金将被罚没并赔付给买家。",
  rules56: "第十一条 罚没保证金扣除服务费",
  rules57:
    "1.因买家违约或违规导致买家缴纳的保证金被罚没给卖家的，将不退还服务费，并有权在罚没保证金时直接扣除。",
  rules58:
    "2.因卖家违约或违规导致卖家缴纳的保证金被罚没给买家的，将针对实际情况扣除相应的入驻保证金。",
  rules59:
    "3.特殊情况：对于保证金的返还或扣罚您有任何异议，可通过平台申诉，平台作为中间方，公平协调买、卖家进行责任判定是否返还保证金或做相应扣罚处理。",
  rules60: "第十二条",
  rules61:
    "上传信息应当包含但不限于：类型、品类品项规格、吨数、入库时间、捕捞方式、冷冻方式、捕捞海域、售卖方式、货源方、货源照片、货源描述等。",
  rules62:
    "货源描述：名称、重量大小、等级、野生/养殖、货源形态（原条/切割）、规格、冷冻方式、包装情况、定重过磅扣点等其他补充信息。",
  rules621: "订单描述：品类、价格、发货地，发票信息等。",
  rules63: "第十三条 交易方式及选择建议",
  rules64: "1.用户可以选择自行登录平台竞价和挂牌。",
  rules65:
    "2.延时：在竞价结束前倒计时1分钟内，如有任何人出价，则该拍卖在该出价时间基础上自动延时3分钟，以此类推，直到在倒计时结束前1分钟无人继续出价，竞拍结束",
  rules66: "注意事项",
  rules67: "注意要设置采购数量门槛，防止恶意竞价。例：一吨货物低价竞争。",
  rules68: "了解市场价格趋势，确保交易顺利进行。",
  rules69: "货源详情记录清晰，确保交易质量。",
  rules70: "货源详情记录清晰，确保交易质量。",
  rules71: "选择建议",
  rules72: "货品价格有下降趋势，预算有限的情况下建议选择。",
  rules73: "节省服务费，对货品市场价格把控精准且长期购买货物的建议选择。",
  rules74:
    "货源优质且市场价格稳定或有上升趋势，货主不清楚货源价值，想更高价格售出的建议选择。",
  rules75: "节省服务费，价位有明确心理预期的建议选择。",
  rules76: "第三章 实物交收",
  rules77: "第十四条",
  rules78: "中心交易成功后，买卖家办理标的出库、权益变更及交割等事宜。",
  rules79: "第十五条",
  rules80:
    "履约约定：成交后，买卖双方客户有任何一方出现毁约行为（符合保证金扣罚的情形），除履行客诉流程、保证金扣罚外，该客户也将纳入交易中心客户黑名单，影响或限制参与后续交易。",
  rules81: "第四章 附则",
  rules82: "第十六条",
  rules83: "本规则的解释权和修定权属于全球大宗水产品交易平台所有。",
  rules84: "第十七条",
  rules85:
    "全球大宗水产品交易平台有权根据交易平台需求对保证金规则进行修订和调整，修订后的规则将通过站内信、网站公示等合适的方式通知用户。如用户在保证金规则修订后继续使用本交易平台且缴纳了保证金的，则视为用户已经完全理解并接受修订后的保证金规则，同意本交易平台根据修订后的规则管理用户缴纳的保证金。",
  rules86: "第十八条",
  rules87:
    "因本规则产生的争议各方应友好协商解决，协商无法解决的，各方均同意将争议事项提交至相关仲裁部门，按申请仲裁时该院现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对各方均有约束力。",
  rules88: "第十九条",
  rules89:
    "本规则的解释和执行均适用中国大陆地区的法律，本规则的任何条款被认定为无效的不影响其他条款的效力。",
  rules90: "第二十条",
  rules91: "本规则自发布之日起执行。",
  contact1: "电话：400-101-2799",
  contact2: "邮箱：mail@huacaizhaoyu.com",
  contact3: "地址：北京市朝阳区八里庄陈家林9号院华腾世纪总部公园E1座601A",
  contact4: "扫一扫",
  contact5: "查看小程序",
  contact6: "关注",
  contact7: "微信公众号",

  indexnew1: "打造全球高端水产品在线交易平台",
  indexnew2:
    "经深圳市政府批准，由中国农业发展集团、深圳港集团共同发起，由北京华采提供技术支持。做为深圳国家远洋渔业基地的先导项目投入运营。",
  indexnew3: "标准化评级定价系统",
  indexnew4: "专业品控团队",
  indexnew5: "AI技术",
  indexnew6: "溯源",
  indexnew7: "交割系统",
  indexnew8: "交割仓网络",
  indexnew9: "信用系统",
  indexnew10: "客户评级",
  indexnew11: "平台担保",

  delivery1: "全球大宗水产品交易平台全球交割仓",
  delivery2: "为交易中心的金枪鱼提供全球化的交割服务",
  delivery3:
    "全球交割仓包括交易中心自有的交割仓和与国内外合作伙伴共建的交割仓，涵盖了金枪鱼主要产区和消费区的重要城市和港口。",
  delivery4: "国际化、规范化、专业化、品牌化",
  delivery5:
    "全球交割仓的建设和发展，为交易中心的金枪鱼提供更加便利、高效、安全、可靠的交割服务，扩大交易中心的国际影响力和知名度。",
  delivery6: "加强与国内外合作伙伴的合作",
  delivery7:
    "交易中心将继续加强与国内外合作伙伴的合作，扩大全球交割仓的网络和覆盖范围。",
  delivery8: "覆盖主要沿海集散地城市",
  delivery9:
    "覆盖国内主要沿海集散地城市：大连、青岛、舟山、福州、深圳、高雄等；覆盖中国及东亚地区：东京、釜山、曼谷等；",
  delivery10:
    "深圳国际金枪鱼交易中心全球交割仓是指交易中心在全球范围内建立的交割仓库网络，旨在为交易中心的金枪鱼提供全球化的交割服务。全球交割仓包括交易中心自有的交割仓和与国内外合作伙伴共建的交割仓，涵盖了金枪鱼主要产区和消费区的重要城市和港口。",
  delivery11:
    "全球交割仓的建设和发展，是交易中心实现“国际化、规范化、专业化、品牌化”的发展战略的重要组成部分。全球交割仓的建设和发展，可以为交易中心的金枪鱼提供更加便利、高效、安全、可靠的交割服务，扩大交易中心的国际影响力和知名度。",
  delivery12:
    "目前，交易中心已经在国内主要沿海集散地城市与多家行业头部企业和机构建立了意向合作关系。未来，交易中心将继续加强与国内外合作伙伴的合作，扩大全球交割仓的网络和覆盖范围，提高交割服务的质量和效率，为客户提供更加优质的服务和更加便利的交割方式。",
  delivery13: "交割仓网络阶段建设发展规划：",
  delivery14:
    "第一阶段：覆盖国内主要沿海集散地城市：大连、青岛、舟山、福州、深圳、高雄等；",
  delivery15: "第二阶段：覆盖中国及东亚地区：东京、釜山、曼谷等；",
  delivery16: "第三阶段：覆盖一带一路国家主要集散地城市。",
  rksj: "入库时间",
  szjg: "深圳价格",
  nian: "年",
  yue: "月",
  zajzzz: "正在加载",
  flllll: "分类",
  xia: "阿根廷红虾",
  xue: "银鳕鱼",

  zhgll: "账号关联",
  ztzh1: "主体账号",
  dqdlzh1: "（当前登录帐号）",
  yglfh1: "已关联副号",
  xz1: "新增",
  bzmc1: "备注名称",
  cz1: "操作",
  tjxgbz: "添加/修改备注",
  dqzhybgl: "当前帐号已被关联",
  ryywqlx: "如有疑问，请联系",

  glzh1: "关联账号",
  qsrxygldsjh: "请输入需要关联的手机号",
  qsrbz1: "请输入备注（八个字以内）",
  dqgldsjh1: "当前关联的手机号",
  glcg: "关联成功",
  cczjyjscsfjx: "此操作将永久删除, 是否继续?",
  tss1: "提示"
};



// WEBPACK FOOTER //
// ./src/lang/zh.js